import React, { useEffect, useState } from 'react'
import { FormData, InputDiv, InputLabel, InputData, SelectData } from './style'
import { useNavigate, useParams } from 'react-router-dom'
import close from '../../assets/close-icon.svg'
import plus from '../../assets/productions/plus.svg'
import ModalTest from '../BaseModal'
import ApiService from '../../services/ApiService'
import {
  BottomDiv,
  Button,
  ButtonContainer,
  CloseDiv,
  ContainerOfModal,
  Header,
  HeaderTitle,
} from '../styles/modal-style'

const AddOpInPcp = () => {
  const [machineOptions, setMachineOptions] = useState([])
  const [serviceOptions, setServiceOptions] = useState([])
  const [formData, setFormData] = useState({
    machineId: '',
    serviceId: '',
  })
  const navigate = useNavigate()
  const { stageId } = useParams()
  const params = { stageId }

  const handleCreate = () => {
    ApiService.services.updateService(Number(formData.serviceId), {
      machineId:Number(formData.machineId)
    })
    .then((response: any) => {
      if(response.data) navigate('..')
    })
    .catch((error: any) => {
      console.error(error)
    })
  }

  useEffect(() => {
    handleGetAllMachines()
    handleGetAllServices()
  }, [])

  const handleGetAllMachines = () => {
    ApiService.productionFlow.getMachines(params)
    .then((response: any) => {
      if(response.data) setMachineOptions(response.data)
    })
    .catch((error: any) => {
      console.error(error)
    })
  }

  const handleGetAllServices = () => {
    ApiService.services.getServices(params)
    .then((response: any) => {
      if(response.data) setServiceOptions(response.data)
    })
    .catch((error: any) => {
      console.error(error)
    })
  }

  return (
    <ModalTest>
      <ContainerOfModal>
        <Header>
          <HeaderTitle>Adicionar OP</HeaderTitle>
          <CloseDiv onClick={() => navigate('..')}>
            {' '}
            <img src={close} />{' '}
          </CloseDiv>
        </Header>
        <FormData>
          <InputDiv>
            <InputLabel>Máquina</InputLabel>
            <SelectData
              onChange={(e: any) =>
                setFormData((prev) => ({ ...prev, machineId: e.target.value }))
              }
            >
              <option value={formData.machineId}>Selecione</option>
              {machineOptions.map((machine: any, index) => (
                <option key={index} value={machine.id}>
                  {machine.id}
                </option>
              ))}
            </SelectData>
          </InputDiv>
          <InputDiv>
            <InputLabel>Selecionar OP</InputLabel>
            <SelectData
              onChange={(e: any) =>
                setFormData((prev) => ({ ...prev, serviceId: e.target.value }))
              }
            >
              <option value={formData.serviceId}>Selecione</option>
              {serviceOptions.map((service: any, index) => (
                <option key={index} value={service.id}>
                  {service.id}
                </option>
              ))}
            </SelectData>
          </InputDiv>
        </FormData>
        <BottomDiv>
          <ButtonContainer>
            <Button onClick={() => navigate('..')} className='cancel'>
              Cancelar
            </Button>
            <Button onClick={() => handleCreate()}>
              <img src={plus} /> Adicionar OPs
            </Button>
          </ButtonContainer>
        </BottomDiv>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default AddOpInPcp

